<template>
    <!-- Current process beside the Forge's version, then what changed. Shared by Process health's "Fix in the Forge"
         (AIHub.vue) and team suggestions drafted by the Forge (ForgeSuggestionDraft.vue). -->
    <div class="fc">
        <div class="ai-detail-cols">
            <div>
                <div class="ai-detail-label">Current version</div>
                <div class="ai-detail-preview ai-detail-old">
                    <div v-for="(item, i) in current" :key="i" class="ai-detail-item">
                        <div class="ai-detail-header">{{ item.header }}</div>
                        <div v-html="renderBody(item.body)"></div>
                    </div>
                </div>
            </div>
            <div>
                <div class="ai-detail-label">{{ draftLabel }} <slot name="draft-label"></slot></div>
                <div class="ai-detail-preview ai-detail-new">
                    <div v-for="(item, i) in draft" :key="i" class="ai-detail-item">
                        <div class="ai-detail-header">{{ item.header }}</div>
                        <div v-html="renderBody(item.body)"></div>
                    </div>
                </div>
            </div>
        </div>
        <div class="ai-detail-label" style="margin-top:14px">{{ changesLabel }}</div>
        <ul class="ai-changelist">
            <li v-for="(c, i) in changes" :key="i">{{ c }}</li>
        </ul>
    </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue';

export default defineComponent({
    name: 'ForgeCompare',
    props: {
        current: { type: Array, default: () => [] },
        draft: { type: Array, default: () => [] },
        changes: { type: Array, default: () => [] },
        draftLabel: { type: String, default: 'AI improved version' },
        changesLabel: { type: String, default: 'What the improved version changes' }
    },
    methods: {
        // Process bodies are the app's own stored HTML (shown the same way on the process page); [confirm: ...] marks
        // facts the owner must fill in
        renderBody(html: string): string {
            return (html || '').replace(/\[confirm:([^\]]*)\]/g, '<span class="ai-confirm-flag">[confirm:$1]</span>');
        }
    }
});
</script>

<style scoped>
.ai-detail-cols { display: grid; grid-template-columns: 1fr 1fr; gap: 16px; }
@media (max-width: 900px) { .ai-detail-cols { grid-template-columns: 1fr; } }
.ai-detail-label { font-weight: bold; text-transform: uppercase; font-size: 12px; letter-spacing: .06em; color: #888; margin-bottom: 6px; }
.ai-detail-preview { border-radius: 6px; border: 1px solid #e2e2e2; max-height: 340px; overflow: auto; padding: 4px 14px; font-size: 14px; }
.ai-detail-old { background: #fafafa; }
.ai-detail-new { background: linear-gradient(135deg, #fffaf5, #fff4ea); border-color: var(--ai-border-soft); box-shadow: 0 2px 8px rgba(234, 88, 12, .08); }
.ai-detail-item { padding: 10px 0; border-bottom: 1px solid #ececec; }
.ai-detail-item:last-child { border-bottom: none; }
.ai-detail-header { font-weight: bold; margin-bottom: 4px; }
.ai-detail-preview :deep(p) { margin: 5px 0; }
.ai-detail-preview :deep(ul), .ai-detail-preview :deep(ol) { margin: 5px 0; padding-left: 20px; }
.ai-detail-preview :deep(.ai-confirm-flag) { background: #fff3cd; border: 1px solid #ffe08a; color: #8a6d00; border-radius: 4px; padding: 0 4px; font-size: 12px; }
.ai-changelist { margin: 4px 0 0; padding-left: 20px; }
.ai-changelist li { margin-bottom: 4px; }
</style>
